import { createContext } from "react";

const DatePickerContext = createContext();

export default DatePickerContext;
